import {FormProvider, useForm} from 'react-hook-form'
import {FC, ReactNode} from 'react'
import {UserAvailability} from '@/features/users-availability/types'
import {zodResolver} from '@hookform/resolvers/zod'
import {AvailabilityFormValidationSchema} from '@/features/users-availability/utils'

interface UserAvailabilityFormProviderProps {
    defaultValues: UserAvailability
    children: ReactNode
}

export const UserAvailabilityFormProvider: FC<UserAvailabilityFormProviderProps> = ({defaultValues, children}) => {
    const form = useForm<AvailabilityFormValidationSchema>({
        mode: 'onBlur',
        reValidateMode: 'onSubmit',
        resolver: zodResolver(AvailabilityFormValidationSchema),
        defaultValues: defaultValues // No need for 'as' since we've established compatibility
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
